module.exports = __webpack_public_path__ + "static/media/ball_004_c.6532e07c.png";